import React from "react";
import PDFIcon from "../../../../../../../assets/images/icons/pdf-file.png";
import DWGIcon from "../../../../../../../assets/images/icons/dwg-file.png";
import MSGIcon from "../../../../../../../assets/images/icons/msg-file.png";
import DocumentIcon from "../../../../../../../assets/images/icons/document-file.png";
import CSVIcon from "../../../../../../../assets/images/icons/csv-file.png";
import TXTIcon from "../../../../../../../assets/images/icons/txt-file.png";
import JPGIcon from "../../../../../../../assets/images/icons/jpg-file.png";
import PNGIcon from "../../../../../../../assets/images/icons/png-file.png";
import BlankIcon from "../../../../../../../assets/images/icons/blank-file.png";

const extensionFrom = (value = "") => {
  const clean = String(value).split("?")[0].split("#")[0];
  const base = (clean.split("/").pop() || "").trim();
  const dot = base.lastIndexOf(".");
  if (dot <= 0 || dot === base.length - 1) return "";
  return base.slice(dot + 1).toLowerCase();
};

const resolveExtension = (file) => {
  const attrs = file?.data?.attributes || {};
  const candidates = [attrs.fileName, attrs.name, attrs.filePath];
  for (let i = 0; i < candidates.length; i += 1) {
    const extension = extensionFrom(candidates[i] || "");
    if (extension) return extension;
  }
  return "";
};

export default function FileIcon({ file }) {
  const matchIconByExtension = (extension) => {
    switch (extension) {
      case 'pdf':
        return PDFIcon;
      case 'dwg':
        return DWGIcon;
      case 'msg':
        return MSGIcon;
      case 'csv':
        return CSVIcon;
      case 'txt':
        return TXTIcon;
      case 'jpg':
      case 'jpeg':
      case 'jpe':
      case 'jfif':
        return JPGIcon;
      case 'png':
        return PNGIcon;
      case 'doc':
      case 'docx':
      case 'xls':
      case 'xlsx':
        return DocumentIcon;
      case '':
        return BlankIcon;
      default:
        return BlankIcon;
    }
  };

  const fileExtension = resolveExtension(file);
  const icon = matchIconByExtension(fileExtension);

  return <img src={icon} alt={`${fileExtension || 'blank'} icon`} style={{ width: '20px', height: '20px' }} />;
}
